import React from "react";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Typography,
} from "@mui/material";

const posts = [
  {
    title: "Understanding Different Types of Commercial Cleaning Services",
  },
  {
    title: "The Importance of Post-Construction Cleaning: What You Need to Know",
  },
  {
    title: "How to Keep Your Office Germ-Free Between Cleanings",
  },
];

const BlogSection = () => (
  <Container sx={{ py: 7 }}>
    <Grid
      container
      spacing={3}
      alignItems="center"
      justifyContent="space-between"
      mb={2}
    >
      <Grid item xs={12} md="auto">
        <Typography
          sx={{
            fontSize: 14,
            textTransform: "uppercase",
            letterSpacing: "0.2em",
            color: "#7ac142",
          }}
        >
          Blog & News
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 800 }}>
          Get Latest News & Updates
        </Typography>
      </Grid>
      <Grid item xs={12} md="auto">
        <Button
          variant="outlined"
          sx={{
            borderRadius: 999,
            px: 3,
            textTransform: "none",
          }}
        >
          View All Posts
        </Button>
      </Grid>
    </Grid>

    <Grid container spacing={3}>
      {posts.map((p, idx) => (
        <Grid item xs={12} md={4} key={idx}>
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: "0 16px 50px rgba(0,0,0,0.06)",
              overflow: "hidden",
            }}
          >
            <CardActionArea>
              <CardMedia
                component="img"
                height="180"
                image="https://html.themehour.net/kleanix/demo/assets/img/blog/blog_1_1.jpg"
                alt={p.title}
              />
              <CardContent>
                <Typography
                  gutterBottom
                  sx={{ fontWeight: 700, fontSize: 16, mb: 1 }}
                >
                  {p.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: 13 }}
                >
                  Learn practical tips and insights from our cleaning experts.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Container>
);

export default BlogSection;
